import { useEffect, useState } from "react";
import { auth } from "../firebaseConfig";
import { onAuthStateChanged, signInWithEmailAndPassword, createUserWithEmailAndPassword, signOut } from "firebase/auth";

export default function useAuth(){
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(()=>{
    const unsub = onAuthStateChanged(auth, (u)=>{
      setUser(u);
      setLoading(false);
    });
    return ()=>unsub();
  },[]);

  const login = (email, password)=> signInWithEmailAndPassword(auth, email, password);
  const signup = (email, password)=> createUserWithEmailAndPassword(auth, email, password);
  const logout = ()=> signOut(auth);

  return { user, loading, login, signup, logout };
}
